import { FC, useEffect, useRef, HTMLAttributes } from 'react'

const isAvailable = 'MutationObserver' in window

type SubtreeMutationProps =
  & HTMLAttributes<HTMLDivElement>
  & {
    options?: MutationObserverInit
    onChange?: (event: MutationRecord[]) => void
  }

export const SubtreeMutation: FC<SubtreeMutationProps> = (props) => {
  const { children, options, onChange, ...restProps } = props

  const rootRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const { current } = rootRef
    if (!isAvailable || !onChange || !current) {
      return
    }

    const observer = new MutationObserver(onChange)
    observer.observe(current, {
      subtree: true,
      childList: true,
      ...options,
    })

    return () => {
      observer.disconnect()
    }
  }, [onChange, options])

  return (
    <div ref={ rootRef } { ...restProps }>
      { children }
    </div>
  )
}
